<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCartStore } from '@/store/cart';
import { useMainStore } from '@/store/main';
import { useProductsStore } from '@/store/products';

const route = useRoute();
const router = useRouter();
const cartStore = useCartStore();
const mainStore = useMainStore();
const productsStore = useProductsStore();

onMounted(() => {
	const query = { ...route.query };
	mainStore.planCategory = null;
	productsStore.selectedPlanType = undefined;
	mainStore.setSignupType(productsStore.portal?.options.defaultSignupType || null);
	cartStore.clearCart();
	delete query.type;
	router.push({ name: 'subscribe', query: { ...query, step: 1 } });
});
</script>

<template>
	<div />
</template>
